import DOMPurify from "dompurify";

/**
 * Strips all HTML tags from a string, returning plain, trimmed text.
 * Used wherever rich-text content (e.g. a bold-enabled question) needs to be
 * shown or compared as plain text (validation, summaries, table cells, CSV, etc.).
 */
export const stripHtml = (html: string): string => {
  if (!html) return "";
  const div = document.createElement("div");
  div.innerHTML = html;
  return (div.textContent || div.innerText || "").replace(/\s+/g, " ").trim();
};

/** Allow-list for rich text that only supports bold formatting (plus paragraphs/line breaks). */
const BOLD_ONLY_TAGS = ["p", "strong", "b", "br"];

/**
 * Sanitizes HTML produced by a bold-only rich text editor, stripping everything
 * except paragraph/line-break structure and bold marks. Safe to pass to
 * `dangerouslySetInnerHTML`.
 */
export const sanitizeBoldHtml = (html: string): string =>
  DOMPurify.sanitize(html || "", { ALLOWED_TAGS: BOLD_ONLY_TAGS, ALLOWED_ATTR: [] });
